import React from 'react';

import { useAddTags, useIsUpdating } from 'scenes/GalleryTags/data/mutations';

import AddsTagForm from './AddTagsForm';
import { CATEGORY } from './constants';

const AddsTag = ({
  initialValues = {},
  onSubmit,
  onClose,
  onExited,
  open,
  onAddCategory,
}) => {
  const [addTags] = useAddTags();
  const isUpdating = useIsUpdating();
  const handleSubmit = async (values) => {
    const newTags = values.tags.filter(({ id }) => !id);
    const response = await addTags({ id: values[CATEGORY].id, tags: newTags });

    onSubmit(response);
  };

  return (
    <AddsTagForm
      loading={isUpdating}
      onClose={onClose}
      initialValues={initialValues}
      onSubmit={handleSubmit}
      onExited={onExited}
      open={open}
      onAddCategory={onAddCategory}
    />
  );
};
export default AddsTag;
